import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { discoverMcpConnector } from '@/services/mcp-gateway';

export function useDiscoverMcpConnector() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (connectorId: string) => discoverMcpConnector(connectorId, orgId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['mcp-connectors', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['mcp-tools', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['mcp-connector-tools', orgId] });
    },
  });
}
